const apiUrls = {
  auth: {
    sign: {
      signIn: "/api/sign/in",
      signInPhone: "/api/sign/in-phone",
      signUp: "/api/sign/up",
      refreshToken: "/api/sign/refresh-token",
      activate: "/api/sign/activate-with-phone",
      signOut: "/api/sign/out",
      resetPassword: "/api/sign/reset-password",
      forgotPassword: "/api/sign/forgot",
      forgotPasswordReset: "/api/sign/forgot-reset",
    },
    user: {
      me: "/api/user/me",
      withUserCode: "/api/user",
      userProfile: "/api/user/user-profile",
      userProfileWithEmail: "/api/user/e-mail",
      userProfileWithPhone: "/api/user/phone",
      addGroup: "/api/user/group/all",
      userPage: "/api/user/page",
    },
  },
  salon: {
    salon: {
      salon: "/api/Salon",
      checkPath: "/api/Salon/check-path",
      all: "/api/Salon/all",
      status: "/api/Salon/status",
      byOwner: "/api/Salon/by-owner",
    },
    customSalonData: {
      customSalonData: "/api/CustomSalonData",
    },
    userBan: {
      ban: "/api/UserBan",
      bySalon: "/api/UserBan/salon",
      byUser: "/api/UserBan/user",
      isBanned: "/api/UserBan/is-banned",
    },
  },
  finance: {
    transaction: {
      transaction: "/api/Transaction",
      getBySalon: "/api/Transaction/by-salon",
      monthlyReport: "/api/Transaction/monthly-report",
      monthlyStats: "/api/Transaction/monthly-finance-stats",
    },
    balance: {
      getBySalon: "/api/Balance",
    },
  },
  inventory: {
    inventory: {
      getBySalon: "/api/Inventory/by-salon",
      inventory: "/api/Inventory",
    },
  },
  subscription: {
    subscriptionCustomer: {
      createPWILink: "/api/SubscriptionCustomer/customer/create-and-pay",
      completePWILink: "/api/SubscriptionCustomer/customer/payment/complete",
      activeSub: "/api/SubscriptionCustomer/customer/active",
    },
  },
  service: {
    service: {
      service: "/api/Service",
      getBySalon: "/api/Service/by-salon",
      getCountBySalon: "/api/Service/count-by-salon",
    },
  },
  employee: {
    employee: {
      employee: "/api/Employee",
      getBySalon: "/api/Employee/by-salon",
      getCountBySalon: "/api/Employee/count-by-salon",
      updateWorkhours: "/api/Employee/update-workhours",
      updatePosition: "/api/Employee/position",
      updateIsActive: "/api/Employee/is-active",
      updateServices: "/api/Employee/services",
      addEmployeeLeave: "/api/Employee/add-employee-leave",
      deleteEmployeeLeave: "/api/Employee/delete-employee-leave",
      addEmployeeRecurringLeave: "/api/Employee/add-recurring-leave",
      deleteEmployeeRecurringLeave: "/api/Employee/delete-recurring-leave",
      byUserCode: "/api/Employee/by-user-code",
    },
  },
  appointment: {
    appointment: {
      bySalon: "/api/Appointment/by-salon",
      bySalonFiltered: "/api/Appointment/by-salon-filtered",
      bySalonFilteredCount: "/api/Appointment/by-salon-filtered-count",
      appointment: "/api/Appointment",
      appointmentCustomerFree: "/api/Appointment/customer-free",
      customersBySalon: "/api/Appointment/customers-by-salon",
      appointmentsByCustomer: "/api/Appointment/by-customer",
      myAppointments: "/api/Appointment/my-appointments",
      updateStatus: "/api/Appointment/update-status",
      availableTimeSlots: "/api/Appointment/available-time-slots",
      monthlyStats: "/api/Appointment/monthly-stats",
    },
  },
  file: {
    file: {
      announcement: "/api/File/announcement",
      content: "/api/File/content",
      profilePhoto: "/api/File/profile-photo",
    },
  },
  content: {
    contact: {
      contact: "/api/contact",
      contactPaged: "/api/contact/page",
      contactRead: "/api/contact/read",
    },
  },
};

export default apiUrls;
